/**
 * 매장 페이지 장바구니 금액·할인 계산.
 * store route 전용 util.
 */

export interface CartItemForTotal {
  product: {
    price: number;
    userPrice?: number | null;
  };
  quantity: number;
}

/**
 * 장바구니 총 결제 예정 금액을 계산한다 (userPrice 우선, 없으면 price).
 */
export function getTotalAmount(cart: CartItemForTotal[]): number {
  return cart.reduce((total, item) => {
    const price = item.product.userPrice ?? item.product.price;
    return total + price * item.quantity;
  }, 0);
}

/**
 * 장바구니에서 받은 총 할인액을 계산한다.
 */
export function getTotalDiscount(cart: CartItemForTotal[]): number {
  return cart.reduce((total, item) => {
    const userPrice =
      item.product.userPrice !== undefined && item.product.userPrice !== null
        ? item.product.userPrice
        : item.product.price;
    const hasDiscount = userPrice < item.product.price;
    const discount = hasDiscount ? item.product.price - userPrice : 0;
    return total + discount * item.quantity;
  }, 0);
}
